import {
  CorporationDto,
  CorporationStatus
} from './../../models/corporation/corporation.dto';

export const corporateMock: CorporationDto[] = [
  {
    id: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
    name: 'Wasatch Peak Technologies',
    description:
      'Soluciones de software especializado en logística de montaña.',
    email: 'contact@wasatchpeak.com',
    phone: '+1 (801) 555-0123',
    website: 'https://wasatchpeak.io',
    logoUrl: 'https://cdn.example.com/logos/wasatch.png',
    address: '251 S State St',
    addressLine1: 'Suite 400',
    addressLine2: null,
    city: 'Salt Lake City',
    state: 'Utah',
    postalCode: '84111',
    zipCode: '84111',
    country: 'USA',
    timeZone: 'Mountain Standard Time (MST)',
    businessHours: 'Mon-Fri 09:00-18:00',
    isActive: true,
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2026-02-20T15:45:00Z',
    status: CorporationStatus.Active,
    locations: null
  },
  {
    id: 'a12bc34d-56ef-78gh-90ij-1k2l3m4n5o6p',
    name: 'Red Rock Logistics Group',
    description: 'Servicios de transporte y distribución en el área de Moab.',
    email: 'info@redrocklogistics.net',
    phone: '+1 (435) 555-9876',
    website: 'https://redrocklogistics.com',
    logoUrl: null,
    address: '1141 S Main St',
    addressLine1: 'Building B',
    addressLine2: 'Unit 12',
    city: 'Moab',
    state: 'Utah',
    postalCode: '84532',
    zipCode: '84532',
    country: 'USA',
    timeZone: 'Mountain Standard Time (MST)',
    businessHours: 'Mon-Sat 08:00-20:00',
    isActive: false,
    createdAt: '2025-06-12T08:00:00Z',
    updatedAt: null,
    status: CorporationStatus.PendingApproval,
    locations: null
  }
];
